import get from "lodash/get"
import { isTopMostOfType } from "../utils/helper"

export default {
  uiTypes: ["input"],
  props: {
    name: String,
    readonly: Boolean,
    disabled: Boolean,
  },
  inject: {
    form: {
      from: "mm-form",
      default: null,
    },
    formField: {
      from: "mm-form-field",
      default: null,
    },
    inputGroup: {
      from: "inputGroup",
      default: null,
    },
  },
  data() {
    return {
      initialData: undefined,
      isTopMostInput: isTopMostOfType(this, "input", "field"),
    }
  },
  computed: {
    realName() {
      return get(this.formField, "name", this.name)
    },
    realDisabled() {
      return this.getState("disabled")
    },
    realReadonly() {
      return this.getState("readonly")
    },

    outForm() {
      return !this.isTopMostInput || !this.form || !this.formField
    },
  },
  created() {
    if (this.outForm) {
      return
    }

    this.$emit = this.realEmit.bind(this, this.$emit)
    this.formField.register(this)
  },
  beforeDestroy() {
    if (this.outForm) {
      return
    }
    this.formField.unregister(this)
  },
  methods: {
    realEmit(originalEmit, eventName, data, event) {
      originalEmit.apply(this, Array.prototype.slice.call(arguments, 1))
      if (eventName.indexOf("hook:") !== 0 && this.formField.ruleField) {
        this.formField.$emit("interact", eventName, data, event)
      }
    },
    getState(state) {
      return [this.form, this.formField, this.inputGroup, this].some(vm => get(vm, state) === true)
    },
  },
}
